import Img from 'gatsby-image'
import Link from 'gatsby-link'
import * as React from 'react'
import Helmet from 'react-helmet'
import Header from '../components/Header'
import MailingListModal from '../components/MailingListModal'
import './About.scss'

interface IProps {
  data: any
}

class About extends React.PureComponent<IProps> {
  public render() {
    const { data } = this.props

    return (
      <div className="page__about__wrapper">
        <div className="page page__about">
          <Helmet title="About" />
          <Header />
          <div className="about__wrapper">
            <div className="about">
              <h1 className="big_title">
                Our mission is to <mark>support people</mark>
              </h1>
              <section className="about__content">
                <p className="about__paragraph">
                  We started <strong className="about__name">Supportive</strong>{' '}
                  because we saw again and again — in our relationship, and in
                  others’ — that people struggle to communicate well.{' '}
                  <em>Especially</em> for the important things.
                </p>
                <p className="about__paragraph">
                  Often, we don’t feel adequately prepared to talk about the tough
                  subjects. Or, we don’t feel like there’s time or space to open
                  up. We wanted to create a modern guide for friends and couples
                  to do just that.
                </p>
                <p className="about__paragraph">
                  Motivated by personal struggles with communication and
                  well-being, we’ve spent months working with young adults in
                  college and out. What came out of that process is{' '}
                  <strong className="about__name">Supportive</strong>, a
                  continually evolving tool for people to use to move through the
                  difficult conversations we all go through.
                </p>
                <p className="about__paragraph">
                  For perhaps one of the only times in our lives, we have the
                  freedom to work on{' '}
                  <strong className="about__name">Supportive</strong> without the
                  goal of making money. And for that, we feel lucky. Our mission
                  is truly to help <em>without any expectation of being paid</em>.
                </p>
                <p className="about__paragraph">
                  If you want to share feedback or schedule a workshop, contact us
                  at{' '}
                  <a href="mailto:clgibbs@stanford.edu">clgibbs@stanford.edu</a>{' '}
                  and{' '}
                  <a href="mailto:andrewslee@stanford.edu">
                    andrewslee@stanford.edu
                  </a>
                </p>
              </section>
              <figure className="about__image">
                <Img
                  alt="Photo of Andrew and Nina"
                  sizes={data.imageSharp.sizes}
                />
                <figcaption>
                  <p className="tiny_subtext">
                    <strong>Above</strong>: Andrew (left) and Nina (right)
                  </p>
                </figcaption>
              </figure>
            </div>
          </div>
          <MailingListModal />
        </div>
      </div>
    )
  }
}

export default About

export const query = graphql`
  query AboutPageImageQuery {
    imageSharp(id: { regex: "/about/" }) {
      sizes(maxWidth: 700) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/about.tsx